///////////////////////////////////////////////////////////////////////////////////
// Containers to hold global lookups, variables and configuration
///////////////////////////////////////////////////////////////////////////////////
const CONFIG = {};
const DATA = {};

let MAP;  // L.Map instance and some constants
var START_LAT  =   37.6490;
var START_LON  = -119.8718;
var START_ZOOM = 6;
var MIN_ZOOM = 6;
var MAX_ZOOM = 17;

///////////////////////////////////////////////////////////////////////////////////
// Global configuration
///////////////////////////////////////////////////////////////////////////////////

// Ready!
$(document).ready(function () {
  initSortAndFilter();
  initMap();
  initMapListSwitcher();
  initProjectGridLinks();
  initLazyLoad();
  initTypeaheadSearch();
  initAppFromURLParams();

  // all set
  setTimeout(function() {
    CONFIG.first_load = false;
  },1500);
});

// Style and config constants
CONFIG.no_image_text = {
  before: 'Image Not Available',
  after: 'Project Underway',
  oep: 'Photo coming soon',
}

// for printing readable grant names
CONFIG.grant_program_lookup = {
  // I don't think these two SPP program names are ever displayed
  'Prop. 84 Statewide Park Program': 'Prop. 84',
  'Prop. 68 Statewide Park Program': 'Prop. 68',
  'OEP': 'Outdoor Equity Program',
  'Outdoor Recreation Legacy Partnership': 'Outdoor Recreation Legacy Partnership',
  // These "historic" program names are displayed in cards
  'lwcf': 'Land and Water Conservation Fund',
  'nef_84': 'Proposition 84 NEF',
  'p12_40': 'Proposition 12/40',
  'Habitat Conservation Fund': 'Habitat Conservation Fund',
  'Recreational Trails Program': 'Recreational Trails Program',
}

// Map popup content is variable between SPP/OEP and "historic" projects
// TODO Edit this to match bond checkbox options
CONFIG.modern_projects = ['Prop. 84 Statewide Park Program','Prop. 68 Statewide Park Program','OEP','Outdoor Recreation Legacy Partnership'];

// string formatting functions
CONFIG.format = {
  'usd': function(n) { return n.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 })},
  'number': function(n) {return parseFloat(n).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0})},
  'float': function(n) {return parseFloat(n).toLocaleString('en-US', {minimumFractionDigits: 1, maximumFractionDigits: 1})},
}

// for tracking search details
CONFIG.typeahead_match = {};

// track map state
CONFIG.map_visible = false;

// track load state
CONFIG.first_load = true;

///////////////////////////////////////////////////////////////////////////////////
// Functions called on Doc ready
///////////////////////////////////////////////////////////////////////////////////

// init the search input at the top of the app as a "typeahead" which provides suggestions as the user types
function initTypeaheadSearch() {
  // trap delete separately using keydown
  $('input.search-text').on('keydown', debounce(function(e) {
    let key = e.keyCode || e.charCode;
    let input = $(this);
    let searchstring = input.val().trim();
    let searchcategory = input.data().searchcategory;

    if ( key == 8 || key == 46 ) {
      if (! searchstring) {
        // On delete and empty search string: hide the dropdowns
        $(`div.search-suggestions[data-searchcategory="${searchcategory}"]`).hide();
        $(`div.search-not-found[data-searchcategory="${searchcategory}"]`).hide();
        $(`span.place-type[data-searchcategory="${searchcategory}"]`).hide();
        CONFIG.typeahead_match[searchcategory] = {};
        searchSortAndFilter();
      }
    }
  }, 300));


  // when the user types into the search input, return a list of matching names from the server
  // using 'input' instead of 'keyup' because focus() triggers 'keyup' but not 'input'
  $('input.search-text').on('input', debounce(function(e) {
    let input = $(this);
    let searchstring = input.val().trim();
    let searchcategory = input.data().searchcategory;
    // only trigger search after after entering a search string with at least 3 characters
    if (searchstring.length > 2) {

      // take matching terms, and format a dropdown list below the search input
      $.get('/data/searchterms', {search_term: searchstring, search_category: searchcategory}, function(results) {
        let target = $(`div.suggestion-wrapper[data-searchcategory="${searchcategory}"]`).empty();
        if (! results.length) {
          $(`div.search-suggestions[data-searchcategory="${searchcategory}"]`).hide();
          $(`div.search-not-found[data-searchcategory="${searchcategory}"]`).show();
        } else {
          $(`div.search-suggestions[data-searchcategory="${searchcategory}"]`).show();
          $(`div.search-not-found[data-searchcategory="${searchcategory}"]`).hide();
          results.sort(function(a, b) {
            // multi-criteria sort: first use the sort item we set in views.py
            // which puts (city) and (county) first, and second, respectively
            if (a.sort < b.sort) return -1;
            if (b.sort > a.sort) return 1; 
            return 0;
          });
          results.forEach(function(result) {
            let match = $('<div>', {
              'class': 'suggestion',
              // text: result.label,
              html: `<span class="search-match"></span>${result.match} <span class="place-type">${result.type}</span>`,
              'aria-label': `${result.match} ${result.type}`,
              'data-searchcategory': searchcategory,
              'data-type': result.type,
              'data-match': result.match,
              'data-id': result.id,
              'tabindex': '0',
            }).appendTo(target).mark(searchstring);
          });
        }
      })    
    }

    // no matter what just happend, update URL params
    composeURLParams();

  }, 300));

  // look for arrow down on the search filter, and if there are suggestions, then focus on the first one 
  // also trap delete/backspace of the entire search string, and respond with a new search 
  $('input.search-text').on('keydown', debounce(function(e) {
    let input = $(this);
    let key = e.keyCode || e.charCode;
    let searchstring = input.val().trim();
    let searchcategory = input.data().searchcategory;

    // delete: clear out the internal search object and search
    if ( key == 8 || key == 46 ) {
      if (! searchstring) {
        // On delete and empty search string: hide the dropdowns
        $(`div.search-suggestions[data-searchcategory="${searchcategory}"]`).hide();
        $(`div.search-not-found[data-searchcategory="${searchcategory}"]`).hide();
        $(`span.place-type[data-searchcategory="${searchcategory}"]`).hide();
        CONFIG.typeahead_match[searchcategory] = {};
        searchSortAndFilter();
      }
    }

    // arrow down: focus on the first suggestion
    if (e.which == '40' && $(`div.search-suggestions[data-searchcategory="${searchcategory}"]`).is(':visible')) {
      $(`div.search-suggestions[data-searchcategory="${searchcategory}"] div.suggestion`).first().focus();
      e.preventDefault();
      return false;
    }
  }, 300));

  // select everything in the input on focus
  $('input.search-text').on('focus focusin', function(e) {
    $(this).select();
  });

  // delegate a click handler on the dynamic typeahead suggestion divs
  // no search is made until the user selects one of these (see searchSortAndFilter) - this just sets up the search term
  $('body').on('click keypress keydown', 'div.suggestion', function(e) {
    // check that we clicked a suggestion, or we hit <enter> on one
    if (e.type == 'keypress' && e.which == 13 || e.type == 'click') {
      // relace the value in the input with the match, 
      // and take a note of the matching details
      let data = $(this).data();
      let searchcategory = data.searchcategory
      let match = data.match;
      let id   = data.id;
      let type = data.type;
      $(`input.search-text[data-searchcategory="${searchcategory}"]`).val(match).attr('aria-label',`${match} ${type}`).focus();
      $(`span.place-type[data-searchcategory="${searchcategory}"]`).text(type).show();

      // update the match 
      CONFIG.typeahead_match[searchcategory] = { id: id, match: match, type: type };

      // got what we need, so hide the suggestions
      $(`div.search-suggestions[data-searchcategory="${searchcategory}"]`).hide();

      // no matter what just happend, submit a search and update URL params
      searchSortAndFilter();
      composeURLParams();

      // prevent bubbling
      e.preventDefault();
      e.stopPropagation();
      return false;
    }

    // check for arrow navigation
    if (e.type == 'keydown' && e.which == 40) {
      $(this).next().focus();
      e.preventDefault();
      return false;
    } 
    if (e.type == 'keydown' && e.which == 38) {
      $(this).prev().focus();
      e.preventDefault();
      return false;
    } 
  });

  // init background click behavior that clears the search input, and closes the suggestions dropdown
  $('body').on('click', function(e) {
    // don't respond to these at all 
    if (e.target.classList.contains('search-text') || e.target.classList.contains('suggestion')) return; 

    // otherwise, we've clicked outside the search control and dropdown
    // always close the dropdows and clear the input
    // conditions: one of the dropdowns is open
    if ($('div.search-suggestions').is(':visible')) {
      // get the search category of the open search suggestions
      let searchcategory = $('div.search-suggestions:visible').data('searchcategory');
      // close the suggestions, hide any "search not found" panel
      $('div.search-suggestions').hide();
      $('div.search-not-found').hide();

      // // blank out the search input for that category
      // // the implication is that there was no selection on a suggestion, so the user has to start over
      // // or keep it blank
      // $(`input.search-text[data-searchcategory="${searchcategory}"]`).val('').focus();
      // $(`span.place-type[data-searchcategory="${searchcategory}"]`).hide();
      // // update params to reflect the change
      // composeURLParams();
    }
  });
}

// init search controls to sort and filter projects that show on the grid and on the map
function initSortAndFilter() {
  // bond filter checks
  $('div#filter-by input[type="checkbox"]').on('change', function() {
    // trigger a search and update URL params
    searchSortAndFilter();
    composeURLParams();
  });

  // page length controls
  $('select#page-size').on('change', function() {
    // trigger a search and update URL params
    searchSortAndFilter();
    composeURLParams();
  });

  // sort by controls
  $('div#sort-by select').on('change', function() {
    // trigger a search and update URL params
    searchSortAndFilter();
    composeURLParams();
  });

  // select all/none buttons
  $('button.select-all-none').on('click', function() {
    let button = $(this);
    let action = button.data('select');
    let checks = button.data('checks');
    if (action === 'all') {
      $(`input[type="checkbox"][name="${checks}"]`).prop('checked', true).trigger('change');
    } else {
      $(`input[type="checkbox"][name="${checks}"]`).prop('checked', false).trigger('change');
    }
  });

  // clear/reset button
  $('div#reset button').on('click', function() {
    // search inputs, clear
    $('input.search-text').val('');
    // bond checkboxes, select SPP only
    $('input[name="bond-checks"]').prop('checked', false);
    $('input[value="spp"]').prop('checked', true);
    // pagination length, reset to 20
    $('select#page-size').val('20');
    // sort, change to alphabetical
    $('select#sort-option').val('project_name');

    // Data: clear search strings
    CONFIG.typeahead_match = {};

    // UI: hide/show results and pills
    $('div#project-grid-empty').hide();
    $('.we-found').hide();
    $('div#project-count').addClass('d-block').removeClass('d-none');
    $('span.place-type').hide();

    // trigger a search and update URL params
    searchSortAndFilter();
    composeURLParams();
  });

  // see also the delegated handler on selection of typeahead suggestions, which also triggers a search...
}

// check for URL params: if found use them to set application state
// if not, init the default application state
function initAppFromURLParams() {
  // if we have params, then parse them
  if (window.location.search) {
    // check for URL params and set filters as appropriate
    let params = new URLSearchParams(window.location.search);
    parseAndApplyURLParams(params);
  } else {
    // no params, just fire off the default search
    $('div#loading').hide();
    searchSortAndFilter();
  }
}

// The actual URL param parsing happens here
// see composeURLParams() where we do the opposite: create and write URL params to the address bar
function parseAndApplyURLParams(params) {
  // set geographic search terms and constants
  if (params.has('geog-search')) {
    let searchparams = params.get('geog-search');
    let searchparts = searchparams.split('|');
    $('input.search-text[data-searchcategory="geography"]').val(decodeURIComponent(searchparts[0]));
    $('span.place-type[data-searchcategory="geography"]').text(decodeURIComponent(searchparts[2])).show();
    CONFIG.typeahead_match.geography = {};
    CONFIG.typeahead_match.geography.match = searchparts[0];
    CONFIG.typeahead_match.geography.id    = searchparts[1];
    CONFIG.typeahead_match.geography.type  = searchparts[2];
  }

  // set name search terms and constants
  if (params.has('name-search')) {
    let searchparams = params.get('name-search');
    let searchparts = searchparams.split('|');
    $('input.search-text[data-searchcategory="name"]').val(decodeURIComponent(searchparts[0]));
    $('span.place-type[data-searchcategory="name"]').text(decodeURIComponent(searchparts[2])).show();
    CONFIG.typeahead_match.name = {};
    CONFIG.typeahead_match.name.match = searchparts[0];
    CONFIG.typeahead_match.name.id    = searchparts[1];
    CONFIG.typeahead_match.name.type  = searchparts[2];
  }

  // bond source
  if (params.has('bond')) {
    let bonds = params.get('bond').split('|');
    // uncheck them all
    $('div#filter-by input[type="checkbox"]').prop('checked', false);
    // check the ones we want 
    bonds.forEach(function(bond) {
      $(`input[value="${bond}"]`).prop('checked', true);
    });
  }

  // set sort
  if (params.has('sort')) {
    let sort = params.get('sort');
    $('select#sort-option').val(sort);
  }

  // set page length
  if (params.has('pagelen')) {
    let pagelen = params.get('pagelen');
    $('select#page-size').val(pagelen); 
  }

  // now that we've set the filters, just run the search
  $('div#loading').hide();
  searchSortAndFilter();

  // set page number, this one is tricky, as pagination needs to be initialized already
  // and that only happens after the first search, so wait a beat for that to complete
  if (params.has('pagenum')) {
    let pagenum = params.get('pagenum');
    // this will trigger a search
    setTimeout(function() {
      $('div#project-paginator').pagination('go', pagenum);
    }, 500);
  } 
}

// compose URL params - see parseAndApplyURLParams() for the inverse function, where we parse and apply these
function composeURLParams() {
  // get the current search params
  let params = new URLSearchParams(window.location.search);

  // set a param to track geography search input value
  params.delete('geog-search');
  if (CONFIG.typeahead_match.geography) {
    if (Object.keys(CONFIG.typeahead_match.geography).length != 0) {
      let match = CONFIG.typeahead_match.geography.match;
      match = encodeURIComponent(match);
      let search = `${match}|${CONFIG.typeahead_match.geography.id}|${CONFIG.typeahead_match.geography.type}`
      params.append('geog-search', search);
    }
  }

  // set a param to track name search input value
  params.delete('name-search');
  if (CONFIG.typeahead_match.name) {
    if (Object.keys(CONFIG.typeahead_match.name).length != 0) {
      let match = CONFIG.typeahead_match.name.match;
      match = encodeURIComponent(match);
      let search = `${match}|${CONFIG.typeahead_match.name.id}|${CONFIG.typeahead_match.name.type}`
      params.append('name-search', search);
    }
  }

  // set a param to track bond sources, which can be 0-many
  params.delete('bond');
  let bonds = $('input[name="bond-checks"]:checked').map(function(i, el){ return el.value; }).get();
  params.append('bond', bonds.join('|'));

  // set a param to track sort
  params.delete('sort');
  let sort = $('select#sort-option').val();
  params.append('sort', sort);

  // set a param to track page length
  params.delete('pagelen');
  let pagelen = $('select#page-size').val();
  params.append('pagelen', pagelen);

  // set a param to track page number
  params.delete('pagenum');
  try {
    // using try/catch because of the async nature of the Ajax call 
    // as well as the many actions that call composeURLParams(), 
    // sometimes the page nubmer property is not available, and that throws a big ugly Type Error. 
    // But don't worry, it will get set in a later pass
    let pagenum = $('div#project-paginator').pagination('getCurrentPageNum');
    params.append('pagenum', pagenum); 
  } catch (e) {
    console.log('Catching a Pagination JS type error, this will likely resolve itself')
  }

  // all set! if we have anything, parse the string, make it a query and
  // replace state in our local address bar
  let searchstring = decodeURIComponent(params.toString());
  if (searchstring) {
    var newparams = '?' + searchstring;
    window.history.replaceState(newparams, '', newparams);
  }
}

// lazy loading proceedures to help with long lists rendering in the DOM
function initLazyLoad() {
  // load images that are already in the viewport, 
  // and set up triggers to load ones as the user scrolls
  load_images(); 
  window.addEventListener('scroll', load_images);
  window.addEventListener('resize', load_images);
}

// When clicking one of the project grid squares, open the link at the bottom
// this combined with a style to underline the link on hover gives the illusion the whole thing is a link
// without the need for additonal markup
function initProjectGridLinks() {
  $('div#project-grid').on('click', 'div.project-outer', function() {
    let link = $(this).find('div.project-label a');
    if (link.length) link[0].click();
  })
}

// there's a L.Map view of the photos' latlng points, with marker clustering and all
function initMap () {
  MAP = L.map('project-map', {
    minZoom: MIN_ZOOM,
    maxZoom: MAX_ZOOM,
    attributionControl: false,
    zoomControl: false,
    keyboard: true,
  })
  .setView([START_LAT, START_LON], START_ZOOM);

  L.tileLayer('https://api.mapbox.com/styles/v1/greeninfo/cin0wlnzz001mahm6u4bzabin/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZ3JlZW5pbmZvIiwiYSI6Ik1HUWRtdEkifQ.aWQKcu787DGrDq7LN5r2iA', {
  	attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    tileSize: 512,
    zoomOffset: -1,
  })
  .addTo(MAP);

  new L.Control.ZoomBar({
    position: 'topright',
    homeLatLng: [START_LAT, START_LON],
    homeZoom: START_ZOOM,
  })
  .addTo(MAP);

  L.control.attribution({
    position: 'bottomright',
  })
  .addTo(MAP)
  .addAttribution('Parks data by <a target="_blank" href="http://www.greeninfo.org">GreenInfo Network</a>.<br />Other data &copy; <a target="_blank" href="https://www.mapbox.com/about/maps/">Mapbox</a> and &copy; <a target="_blank" href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>.');

  // an event handler so the map adjusts to resizing, or being shown/./hidden
  $(window).resize(function () {
    MAP.invalidateSize();
  });

  // the featuregroup for the all project markers: both historic and modern
  // this is actually populated over in renderProjectMap()
  MAP.projectmarkers = L.markerClusterGroup({
    showCoverageOnHover: false,
    zoomToBoundsOnClick: true,
    spiderfyOnMaxZoom: true,
    maxClusterRadius: 20,
  }).addTo(MAP);
}

// init the buttons to switch views between the project grid and the project map
function initMapListSwitcher () {
  const $switch = $('#map-list-switcher');
  const $buttons = $switch.find('button');

  const $panel_list = $('#project-grid');
  const $panel_map = $('#project-map');

  $buttons.click(function () {
    const choice = $(this).attr('data-maplist');

    $buttons.removeClass('selected').filter(`[data-maplist="${choice}"]`).addClass('selected');

    switch (choice) {
      case 'list':
        $panel_list.removeClass('d-none');
        $panel_map.addClass('d-none');
        CONFIG.map_visible = false;

        break;
      case 'map':
        $panel_list.addClass('d-none');
        $panel_map.removeClass('d-none');
        CONFIG.map_visible = true;
        MAP.invalidateSize();

        break;
      default:
        throw new Error('initMapListSwitcher() unexpected button');
    }
  });
  // hack: briefly show the map, seems to help correctly set bounds after the first search
  $buttons.last().click();
  $buttons.first().click();
}


///////////////////////////////////////////////////////////////////////////////////
// Named functions
///////////////////////////////////////////////////////////////////////////////////

// collect all the search terms, sorts and filters at once
// construct a query string, and pass this URL to the paginator to get a page of results from the remote search endpoint 
function searchSortAndFilter() {
  $('div#loading').show();

  // set up an object to hold the search data params
  const search_data = {};

  // if we've logged a match on the typeahead, use it here
  // note that this is distinct from a raw value in the search input. User _must_ have selected a matching item from the list
  if (CONFIG.typeahead_match) {
    let keys = Object.keys(CONFIG.typeahead_match);
    keys.forEach(function(k) {
      search_data[k] = {};
      search_data[k]['search_id']    = CONFIG.typeahead_match[k]['id'];
      search_data[k]['search_type']  = CONFIG.typeahead_match[k]['type'];
      search_data[k]['search_match'] = CONFIG.typeahead_match[k]['match'];
    })
  }

  // if there is a selection on "Bond source", add it to the search_terms
  search_data['bond_checks'] = $('input[name="bond-checks"]:checked').map(function(i, el){ return el.value; }).get();

  // add the selected sort term
  let select = $('select#sort-option');
  let sort_item = select.val();
  search_data['sort_item'] = sort_item ? sort_item : 'project_name';

  // Submit the search and paginate the results
  paginateProjects(search_data);
}

function paginateProjects(search_data) {
  // alright then, go ahead and paginate it! 
  
  if ( $('div#project-paginator').data().pagination ) $('div#project-paginator').pagination('destroy');
  
  $('div#project-paginator').pagination({
    dataSource: '/data/projects/',
    locator: 'data', // needs to match the name of the returned data object
    totalNumberLocator: function(response) {
      // very weird, but this is the only hook I can find that provides the complete Ajax response
      // use it to track the following for the project counter
      CONFIG.dollar_total = response['totaldollars'];
      // then return the total number, which is what this function is actually here for
      return response['totalnumber']
    },
    ajax: {
      data: search_data,
    },
    resetPageNumberOnInit: false,
    pageSize: $('select#page-size').val(),
    position: 'top',
    hideWhenLessThanOnePage: true,
    callback: function(data, pagination) {
      // send this chunk of data to the grid
      renderProjectGrid(data, pagination); 

      // send this chunk of data to the map 
      renderProjectMap(data, pagination);
      
      // update the project counter
      if (data.length) updateProjectCounts(data, pagination);

      // all done! 
      $('div#loading').hide();

      // Hack: position the navigator where we want it and show, since paginationjs does not offer any options for this
      $('div.paginationjs').appendTo($('div#navigator')).show();

      // update URL params

      if (! CONFIG.first_load ) composeURLParams();
    }
  })
}

// given a json object representing projects, render a grid view of project 'cards'
function renderProjectGrid(data) {
  // find our target divs: an outer container, then a top-grid for "modern" projects, and a bottom-grid for "historic"
  var target_grid = $('div#project-grid').empty();

  // hide this initially, show it again if we have nothing to show
  $('div#project-grid-empty').hide();
  $('div.pagination-toggle').show();

  // show this only if there is an area/district search, hide it otherwise
  if ($('input[data-searchcategory="geography"]').val()) {
    $('.we-found').show();
  } else {
    $('.we-found').hide();
  }

  // init some counters, to keep track of pairs of projects
  CONFIG.grid_counter = 0;
  var row_outer;

  if (data.length) {

    data.forEach(function(project, i) {
      // SPP/OEP and all other projects have different representations: 
      // 1. SPP projects have before/after photos 
      // 2. All other projects (OEP, ORLP, LWCF, Rec Trails and Habitat Cons., etc.) sometimes have a single "after" image
      if (project.bond_source === 'Prop. 84 Statewide Park Program' || project.bond_source === 'Prop. 68 Statewide Park Program') {

        // each pair of projects gets an outer row
        if (CONFIG.grid_counter % 2 === 0) {
          row_outer = $('<div>', {'class': 'row row-outer'}).appendTo(target_grid);
        } 
        CONFIG.grid_counter += 1;

        var col_outer = $('<div>', {
          'class': 'col-lg-6'
        }).appendTo(row_outer);

        // and another wrapper that we can give padding to
        var project_outer = $('<div>', {'class': 'project-outer'}).appendTo(col_outer);

        // project label: up top
        var label_wrapper = $('<div>', {'class':'project-label text-center'}).appendTo(project_outer);
        var link = $('<a>', {href: `../project/${project.id}`}).appendTo(label_wrapper);
        $('<p>', {'class': 'project-text', text: project.project_name}).appendTo(link);

        // a row to wrap this pair of before/after images
        var row = $('<div>', {'class': 'row pair top'}).appendTo(project_outer);

        // before col
        var col_before = $('<div>', {'class': 'col'}).appendTo(row);
        var img_wrap_before = $('<div>', {'class': 'img-wrap'}).appendTo(col_before);

        // "before" label
        var label_before = $('<span>', {
          'class': 'img-label before',
          text: 'Before',
        }).appendTo(img_wrap_before);

        // if there's an image add it, if not add an empty span
        if (project.beforeimage) {
          var img = $('<img>', {
            'class': 'img-fluid img-project',
            'data-src': project.beforeimage,
            alt: project.beforealt,
            // load a dummy transparent image initially, then load the actual source when this div is visible in the viewport (see load_images
            src: '../static/images/500x500.png',
          }).appendTo(img_wrap_before);

        } else {
          // no image on the record: append an empty image and div
          var badge_container = $('<div>', {'class': 'badge-container'}).appendTo(img_wrap_before);
          var badge = $('<div>', {'class': 'badge'}).appendTo(badge_container);
          $('<img>', {
            'class': 'img-fluid',
            alt: '',
            src: '../static/images/500x500.png'
          }).appendTo(badge);
          $('<span>', {
            'class': 'no-image-text',
            text: CONFIG.no_image_text.before,
          }).appendTo(badge);
        }

        // after col
        var col_after = $('<div>', {'class': 'col'}).appendTo(row);
        var img_wrap_after = $('<div>', {'class': 'img-wrap'}).appendTo(col_after);

        // "after" label
        var label_after = $('<span>', {
          'class': 'img-label after',
          text: 'After',
        }).appendTo(img_wrap_after);
        
        // if there's an image add it, if not add an empty span
        if (project.afterimage) {
          var img = $('<img>', {
            'class': 'img-fluid img-project',
            'data-src': project.afterimage,
            alt: project.afteralt,
            // load a dummy transparent image initially, then load the actual source when this div is visible in the viewport (see load_images
            src: '../static/images/500x500.png'
          }).appendTo(img_wrap_after);
        } else {
          // no image on the record: append an empty image and div
          var badge_container = $('<div>', {'class': 'badge-container'}).appendTo(img_wrap_after);
          var badge = $('<div>', {'class': 'badge'}).appendTo(badge_container);

          $('<img>', {
            'class': 'img-fluid',
            src: '../static/images/500x500.png'
          }).appendTo(badge);

          let html = $('<div>', {
            'class': 'no-image-text',
          }).appendTo(badge);

          $('<img>', {
            'class': 'construction-image',
            src: '../static/images/construction.svg'
          }).appendTo(html);

          $('<div>', { 
            class: 'underway mb-2',
            html: '<strong>Project Underway</strong>', 
          }).appendTo(html);
          $('<div>', {
            class: 'underway',
            text: 'An investment of'
          }).appendTo(html);
          $('<div>', { 
            class: 'underway',
            html: `<strong>${CONFIG.format['usd'](project.grant_amount)}</strong>`, 
          }).appendTo(html);
          $('<div>', { 
            class: 'underway',
            text: project.grantee, 
          }).appendTo(html);

          $('<div>', {
            class: 'underway mt-2 watch',
            text: 'Watch this space for photos of the project once it is complete!',
          }).appendTo(html);
        }

      } else {
        // every other type of project other than SPP gets at most one photo on the left, and program details on the right
        // each pair of projects gets an outer row
        if (CONFIG.grid_counter % 2 === 0) {
          row_outer = $('<div>', {'class': 'row row-outer'}).appendTo(target_grid);
        } 
        CONFIG.grid_counter += 1;

        var col_outer = $('<div>', {
          'class': 'col-lg-6'
        }).appendTo(row_outer);

        // and another wrapper that we can give padding to
        var project_outer = $('<div>', {'class': 'project-outer'}).appendTo(col_outer);

        // project label: up top
        var label_wrapper = $('<div>', {'class':'project-label text-center'}).appendTo(project_outer);
        var link = $('<a>', {href: `../project/${project.id}`}).appendTo(label_wrapper);
        $('<p>', {'class': 'project-text', text: project.project_name}).appendTo(link);

        // a row to wrap this pair of before/after images
        var row = $('<div>', {'class': 'row pair top'}).appendTo(project_outer);

        // first col
        var col_first = $('<div>', {'class': 'col'}).appendTo(row);
        var img_wrap_before = $('<div>', {'class': 'img-wrap'}).appendTo(col_first);

        // if there's an "after" image add it, if not add an empty span
        if (project.afterimage) {
          var img = $('<img>', {
            'class': 'img-fluid img-project',
            'data-src': project.afterimage,
            alt: project.afteralt,
            // load a dummy transparent image initially, then load the actual source when this div is visible in the viewport (see load_images
            src: '../static/images/500x500.png',
          }).appendTo(img_wrap_before);

        } else {
          // no image on the record: append an empty image and div
          var badge_container = $('<div>', {'class': 'badge-container'}).appendTo(img_wrap_before);
          var badge = $('<div>', {'class': 'badge'}).appendTo(badge_container);
          $('<img>', {
            'class': 'img-fluid',
            alt: '',
            src: '../static/images/500x500.png'
          }).appendTo(badge);

          let text = $('<span>', {
            'class': 'no-image-text',
            text: CONFIG.no_image_text.oep,
          }).appendTo(badge);

          let stack = $('<span>', {
            'class': 'fa-stack fa-2x',
          }).prependTo(text);

          $('<i>', {
            'class': 'fas fa-circle fa-stack-2x'
          }).appendTo(stack);

          $('<i>', {
            'class': 'fas fa-camera fa-stack-1x fa-inverse'
          }).appendTo(stack);
        }

        // second col
        var col_second = $('<div>', {'class': 'col'}).appendTo(row);
        var img_wrap_after = $('<div>', {'class': 'img-wrap'}).appendTo(col_second);
        
        // For OEP, this column contains a few project details
        var badge_container = $('<div>', {'class': 'badge-container'}).appendTo(img_wrap_after);
        var badge = $('<div>', {'class': 'badge'}).appendTo(badge_container);

        $('<img>', {
          'class': 'img-fluid',
          src: '../static/images/500x500.png',
          alt: '',
        }).appendTo(badge);

        let html = $('<div>', {
          'class': 'no-image-text',
        }).appendTo(badge);

        $('<div>', {
          class: 'oep-details',
          text: 'Grant Program',
        }).appendTo(html);

        $('<div>', { 
          class: 'oep-details mb-2',
          // look up a formatted name, falling back to the name from the database
          html: `<strong>${CONFIG.grant_program_lookup[project.bond_source] || project.bond_source}</strong>`, 
        }).appendTo(html);

        $('<div>', {
          class: 'oep-details',
          text: 'Grantee',
        }).appendTo(html);
        
        $('<div>', {
          class: 'oep-details mb-2',
          html: `<strong>${project.grantee}</strong>`,
        }).appendTo(html);

        $('<div>', {
          class: 'oep-details',
          text: 'City',
        }).appendTo(html);

        $('<div>', {
          class: 'oep-details mb-2',
          html: `<strong>${project.city}</strong>`,
        }).appendTo(html);

        $('<div>', {
          class: 'oep-details',
          text: 'Grant Amount',
        }).appendTo(html);

        $('<div>', { 
          class: 'oep-details',
          html: `<strong>${CONFIG.format['usd'](project.grant_amount)}</strong>`, 
        }).appendTo(html);
        
      }    
    }) 

    // all done with the grid, wrap it up with a call to load_images() so that the visible ones get real URLs
    load_images();

  // no data! 
  } else {
    $('div#project-grid-empty').show();
    $('.we-found').hide();
    $('div#project-count').addClass('d-none').removeClass('d-block');
    $('div.pagination-toggle').hide();
  }
}

// update the project counter that reports search results below the search filters
function updateProjectCounts(data, pagination) {
  // Format the total numbers
  let total_number  = CONFIG.format['number'](pagination['totalNumber']);
  let total_dollars = CONFIG.format['usd'](CONFIG.dollar_total);

  // Sum of projects and $$, in the "We found" panel
  let proj_text = total_number > 1 ? 'projects' : 'project';
  let found_text = `We have data about ${total_number} ${proj_text} totaling ${total_dollars} in the area you selected. Note that data about some grant programs is incomplete.`;
  $('#found-message').text(found_text);

  // Simple project count, in the pagination "panel"
  $('div#project-count').addClass('d-block').removeClass('d-none');

  // organize counts
  let min_page = (pagination['pageNumber'] - 1) * pagination['pageSize'] + 1;
  let max_page = pagination['pageNumber'] * pagination['pageSize'];
  if (max_page >= pagination['totalNumber']) max_page = pagination['totalNumber']; 
  // construct range text used in every case: "Results: X to Y of Z...""
  let results_text = `Results: ${min_page}-${max_page} of ${total_number} projects`;
  if (pagination['totalNumber'] == 1) results_text = 'Showing 1 project';

  // enable or disable the next/prev page buttons at the bottom 
  // console.log(pagination['pageNumber']);
  const prev = $('button#prev-page-button');
  let prevDisabled = pagination['pageNumber'] === 1 ? true : false; 
  prev.prop('disabled', prevDisabled); 

  const next = $('button#next-page-button');
  let nextDisabled = parseInt(max_page) === parseInt(total_number)
  next.prop('disabled', nextDisabled);

  // update the pagination message blocks (top and bottom of the page), or leave them blank
  $('.pagination-message').text(results_text);
}

// pairs with renderProjectGrid() in a way, updating the map with markers of that same set of photos
function renderProjectMap (filtered) {
  MAP.projectmarkers.clearLayers();
  MAP.closePopup();

  // exit if there is nothing to map
  if (! filtered) return;
  if (! filtered.length) return; 

  // create markers
  const markers = [];
  
  filtered.forEach(function (project) {
    const marker = L.marker([project.latitude, project.longitude], {
      title: project.project_name,
      properties: project,  // for the popups below
    });
    markers.push(marker);
  });

  // bind popups: popups for the "modern" projects show different attributes than "historic" projects
  // more efficient to use a callback than to bind to each marker
  MAP.projectmarkers.bindPopup(function (marker) {  
    const attributes = marker.options.properties;
    let html;
    if (CONFIG.modern_projects.indexOf(attributes.bond_source) > -1) {
      html = `
      <b>${attributes.project_name}</b>
      <br/>
      ${attributes.grantee}
      <br/>
      <br/>
      <a href="../project/${attributes.id}">View Details <i class="fa fa-chevron-right"></i></a>
      `;
    } else {
      html = `
      <b>${attributes.project_name}</b>
      <br/>
      ${CONFIG.format['usd'](attributes.grant_amount)}
      `;
    }
    return html;
  });

  // add the layers: more efficient to collect them and add them in bulk
  MAP.projectmarkers.addLayers(markers);

  // fit map to bounds, either to the selected set of projects, or if no projects, to the CA BBOX
  let bounds = MAP.projectmarkers.getBounds();
  if (bounds.isValid()) {
    setTimeout(function() { MAP.fitBounds(bounds) }, 200);
  } else {
    MAP.fitBounds([[BBOX_N, BBOX_W],[BBOX_S, BBOX_E]]);
  }
}

// used by the typeahead on the primary search input
var substringMatcher = function(strs) {
  return function findMatches(q, cb) {
    var matches, substringRegex;

    // an array that will be populated with substring matches
    matches = [];

    // regex used to determine if a string contains the substring `q`
    var substrRegex = new RegExp(q, 'i');

    // iterate through the pool of strings and for any string that
    // contains the substring `q`, add it to the `matches` array
    $.each(strs, function(i, str) {
      if (substrRegex.test(str.name)) {
        matches.push(str);
      }
    });
    // fire the callback with sorted matches
    cb(matches.sort());
  };
};

// load images as they come into view
var load_images = function(e) {
  var elements = document.querySelectorAll('.img-project');
  for (var i = 0; i < elements.length; i++) {
    var boundingClientRect = elements[i].getBoundingClientRect();
    if (elements[i].hasAttribute('data-src') && boundingClientRect.top < window.innerHeight) {
      elements[i].setAttribute('src', elements[i].dataset.src);
      elements[i].removeAttribute('data-src');
    }
  }
};

// load project grid items when we scroll to the bottom of the current visible set
var load_projects = function() {
  // only do this when the grid is in fact showing
  if ($('#project-grid').hasClass('d-none')) return;

  // find the lowest grid element
  var bottom = 0;
  var lowest;
  document.querySelectorAll('.project-outer').forEach(function(elem) {
    var rectangle = elem.getBoundingClientRect();
    if (rectangle.bottom > bottom) {
      lowest = elem;
      bottom = rectangle.bottom;
    } 
  });

  // when the lowest grid element is visible, start loading more 
  if (lowest) {
    if (isElementVisible(lowest)) {
      let data = DATA.current_results.splice(0,CONFIG.grid_page_size);
      renderProjectGrid(data);
    }
  }
}

// check if an element is visible in the viewport
function isElementVisible(el) {
  var rect = el.getBoundingClientRect();
  var elemTop = rect.top;
  var elemBottom = rect.bottom;

  // Only completely visible elements return true:
  // var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
  // Partially visible elements return true:
  var isVisible = elemTop < window.innerHeight && elemBottom >= 0;
  return isVisible;
}


// trap enter on the "more info" links, and toggle the collapsed div 
function moreinfoKeyUp(e) {
  if (e.key === 'Enter') {
    e.target.click();
  }
}

// Functions for buttons at the bottom of the gallery results for next and previous
// these are disabled/enabled after search results
function getPreviousPage() {
  $('div#loading').show();
  $('div#project-paginator').pagination('previous');
  setTimeout(function() {
    scrollDownToBottom('prev'); 
    $('div#loading').hide();
  }, 1000);
}

function getNextPage() {
  $('div#loading').show();
  $('div#project-paginator').pagination('next');
  setTimeout(function() {
    scrollDownToBottom('next'); 
    $('div#loading').hide();
  }, 500);
}

function scrollDownToBottom(caller) {
  $('html, body').animate({ scrollTop: $(document).height()-$(window).height() });
}

///////////////////////////////////////////////////////////////////////////////////
// Shims and utilities
///////////////////////////////////////////////////////////////////////////////////

// a little hack to define whether we should "act mobile" in ways that can only be known at runtime
var isMobile = function() { return $(window).width() <= 768; }();

//http://davidwalsh.name/javascript-debounce-function
function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};
